export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">
              51吃瓜黑料网
            </h3>
            <p className="text-sm text-background-300 leading-relaxed">
              51吃瓜黑料网官网在线入口，提供51吃瓜黑料网址直达与51吃瓜黑料入口一二三最新地址，吃瓜黑料入口随时访问，51黑料网吃瓜网地址每日更新不迷路。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: '吃瓜前线', href: '#carousel' },
                { label: '最新爆料', href: '#updates' },
                { label: '黑料榜单', href: '#ranking' },
                { label: '手机吃瓜', href: '#app' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">帮助中心</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: '吃瓜指南', href: '#faq' },
                { label: '爆料投稿', href: '#contact' },
                { label: '关于本站', href: '#about' },
                { label: '读者热评', href: '#comments' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">合作品牌即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 51吃瓜黑料网 保留所有权利。本站内容仅供娱乐参考。
          </p>
          <p className="text-xs text-background-500">
            51吃瓜黑料在线 · 吃瓜黑料入口 · 每日更新不迷路
          </p>
        </div>
      </div>
    </footer>
  );
}